import {REPORT_NEW_ORGANIZATION_CLIENTS} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_ORGANIZATION_CLIENTS,
};
